<div class="ds ds-dialog is-complex contact-dialog" [formGroup]="form">
	<!-- Cabecera -->
	<div class="ds-dialog__head">
		<span class="ds-dialog__icon"><mat-icon>{{ headIcon }}</mat-icon></span>
		<div class="ds-dialog__titles">
			<h2 class="ds-dialog__title">{{ titleKey | translate }}</h2>
			<p class="ds-dialog__sub" *ngIf="contact?.empleadoNombre || data.entityName || data.entityType">
				<ng-container *ngIf="isView || isEdit">{{ contact?.empleadoNombre | nameCase }}</ng-container>
				<ng-container *ngIf="isCreate">{{ entityTypeKey | translate }}<span *ngIf="data.entityName"> · {{ data.entityName }}</span></ng-container>
			</p>
		</div>
		<button type="button" class="ds-dialog__x" (click)="close()" [attr.aria-label]="'common.close' | translate"><mat-icon>close</mat-icon></button>
	</div>

	<!-- Cuerpo único (scrollable) -->
	<div class="ds-dialog__body">
		<!-- Loading -->
		<div class="dlg-state" *ngIf="isLoading$ | async">
			<mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
			<p>{{ "common.loading" | translate }}</p>
		</div>

		<!-- Error -->
		<div class="dlg-state" *ngIf="!(isLoading$ | async) && hasError">
			<mat-icon>error_outline</mat-icon>
			<p>{{ "contacts.detail.loadError" | translate }}</p>
		</div>

		<!-- ===== VIEW ===== -->
		<ng-container *ngIf="!(isLoading$ | async) && !hasError && isView && contact">
			<div class="cd-head">
				<span
					class="cd-av"
					[class.clickable]="hasPhoto"
					(click)="showEmployeePhoto()"
					[matTooltip]="hasPhoto ? ('contacts.clickToViewFullSize' | translate) : ''"
				>
					<img *ngIf="hasPhoto" [src]="photo" [alt]="contact.empleadoNombre" />
					<span *ngIf="!hasPhoto">{{ (contact.empleadoNombre || "·") | slice : 0 : 2 | uppercase }}</span>
				</span>
				<div class="cd-head-tx">
					<div class="cd-oc">{{ contact.puestoDescription || ("contacts.title" | translate) }}</div>
					<h3>{{ (contact.empleadoNombre | nameCase) || ("title.contactDetail" | translate) }}</h3>
				</div>
				<span class="pill info" *ngIf="contact.entidad">{{ contact.entidad }}</span>
			</div>

			<div class="cd-cards">
				<div class="cd-card">
					<div class="sec-head">
						<span class="sec-tile purple"><mat-icon>badge</mat-icon></span>
						<div><h4>{{ "contacts.basicInfo" | translate }}</h4><p>{{ "contacts.detail.basicInfoSub" | translate }}</p></div>
					</div>
					<div class="kv-grid c2">
						<div class="kv"><div class="kv-k">{{ "contacts.empleadoNombre" | translate }}</div><div class="kv-v">{{ (contact.empleadoNombre | nameCase) || "—" }}</div></div>
						<div class="kv"><div class="kv-k">{{ "contacts.puestoDescription" | translate }}</div><div class="kv-v">{{ contact.puestoDescription || "—" }}</div></div>
						<div class="kv"><div class="kv-k">{{ "contacts.empleadoId" | translate }}</div><div class="kv-v" style="font-family: var(--mono)">{{ contact.empleadoId || "—" }}</div></div>
						<div class="kv"><div class="kv-k">{{ "contacts.entidad" | translate }}</div><div class="kv-v">{{ contact.entidad || "—" }}</div></div>
						<div class="kv span2"><div class="kv-k">{{ "contacts.observaciones" | translate }}</div><div class="kv-v">{{ contact.observaciones || ("common.noData" | translate) }}</div></div>
					</div>
				</div>

				<div class="cd-card">
					<div class="sec-head">
						<span class="sec-tile blue"><mat-icon>history</mat-icon></span>
						<div><h4>{{ "contacts.metadata" | translate }}</h4><p>{{ "contacts.detail.metadataSub" | translate }}</p></div>
					</div>
					<div class="kv-grid c2">
						<div class="kv"><div class="kv-k">{{ "contacts.fechaCreacion" | translate }}</div><div class="kv-v">{{ contact.fechaCreacion ? (contact.fechaCreacion | date : "dd/MM/yyyy HH:mm") : "—" }}</div></div>
						<div class="kv"><div class="kv-k">{{ "contacts.usuarioCreacion" | translate }}</div><div class="kv-v">{{ contact.usuarioCreacion || "—" }}</div></div>
						<div class="kv"><div class="kv-k">{{ "contacts.fechaModificacion" | translate }}</div><div class="kv-v">{{ contact.fechaModificacion ? (contact.fechaModificacion | date : "dd/MM/yyyy HH:mm") : "—" }}</div></div>
						<div class="kv"><div class="kv-k">{{ "contacts.usuarioModificacion" | translate }}</div><div class="kv-v">{{ contact.usuarioModificacion || "—" }}</div></div>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- ===== EDIT / CREATE ===== -->
		<ng-container *ngIf="!(isLoading$ | async) && !hasError && (isEdit || isCreate)">
			<div class="ds-dialog__note" *ngIf="isCreate">
				<mat-icon>info</mat-icon>
				<div class="ds-dialog__note-tx"><p>{{ "contacts.form.hints.selectEmployee" | translate }}.</p></div>
			</div>

			<div class="form-row">
				<!-- Empleado: autocomplete en create; solo lectura en edit -->
				<app-empleado-autocomplete
					*ngIf="isCreate"
					formControlName="empleadoId"
					[label]="'contacts.empleado' | translate"
					[placeholder]="'contacts.form.placeholders.selectEmployee' | translate"
					[hint]="'contacts.form.hints.selectEmployee' | translate"
					[required]="true"
					[disabled]="isSaving$ | async"
					(empleadoSelected)="onEmpleadoSelected($event)"
				></app-empleado-autocomplete>

				<div class="ff-field" *ngIf="isEdit">
					<label>{{ "contacts.empleado" | translate }}</label>
					<div class="ff-box is-readonly">
						<input [value]="(contact?.empleadoNombre | nameCase) || ''" disabled />
						<mat-icon class="ff-suffix" [inline]="true">lock</mat-icon>
					</div>
				</div>

				<div class="ff-field">
					<app-ds-select
						formControlName="puestoId"
						[label]="'contacts.puesto' | translate"
						[required]="true"
						[placeholder]="'contacts.form.placeholders.selectPosition' | translate"
						[disabled]="(isSaving$ | async) || (isLoadingPuestos$ | async) || form.get('puestoId')?.disabled"
						[options]="$any(puestos$ | async) || []"
						[optionLabel]="puestoLabelOf"
					></app-ds-select>
					<small class="ff-hint" *ngIf="isCreate && !(isLoadingPuestos$ | async) && !(empleadoSinFuncion$ | async)">{{ "contacts.form.hints.selectEmployeeFirst" | translate }}</small>
					<small class="ff-hint" *ngIf="isLoadingPuestos$ | async">{{ "common.loading" | translate }}...</small>
					<small class="ff-hint warning-hint" *ngIf="empleadoSinFuncion$ | async">⚠️ {{ "contacts.form.noFunctionForEmployee" | translate }}</small>
					<small class="ff-error" *ngIf="form.get('puestoId')?.invalid && form.get('puestoId')?.touched">{{ "contacts.form.errors.positionRequired" | translate }}</small>
				</div>
			</div>

			<app-ds-textarea
				class="full-width"
				formControlName="observaciones"
				[label]="'contacts.observaciones' | translate"
				[rows]="4"
				[placeholder]="'contacts.form.placeholders.observations' | translate"
				[hint]="'contacts.form.hints.optionalField' | translate"
			></app-ds-textarea>
		</ng-container>
	</div>

	<!-- Pie único (varía por modo) -->
	<div class="ds-dialog__footer" *ngIf="!(isLoading$ | async) && !hasError">
		<!-- VIEW -->
		<ng-container *ngIf="isView">
			<button type="button" class="btn btn-danger" (click)="delete()" [disabled]="isSaving$ | async"><span class="ic"><mat-icon>delete</mat-icon></span> {{ "common.delete" | translate }}</button>
			<span style="flex: 1"></span>
			<button type="button" class="btn btn-ghost" (click)="close()">{{ "common.close" | translate }}</button>
			<button type="button" class="btn btn-primary" (click)="enterEdit()"><span class="ic"><mat-icon>edit</mat-icon></span> {{ "common.edit" | translate }}</button>
		</ng-container>

		<!-- EDIT / CREATE -->
		<ng-container *ngIf="isEdit || isCreate">
			<button type="button" class="btn btn-ghost" (click)="cancelEdit()" [disabled]="isSaving$ | async">{{ "common.cancel" | translate }}</button>
			<button type="button" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || (isSaving$ | async)">
				<span *ngIf="!(isSaving$ | async)">{{ (isCreate ? "common.create" : "common.save") | translate }}</span>
				<span *ngIf="isSaving$ | async">{{ "common.saving" | translate }}…</span>
			</button>
		</ng-container>
	</div>
</div>
